module.exports = __webpack_public_path__ + "static/Black-8972b2d6cdf2544cd957e20851ea43c2.webp";